import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export const Route = createFileRoute("/admin/settings")({ component: SettingsPage });

function SettingsPage() {
  const [s, setS] = useState<any>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.settings.get().then((data) => setS(data ?? {}));
  }, []);

  async function save() {
    setSaving(true);
    try {
      await api.settings.set(s);
      toast.success("ההגדרות נשמרו");
    } catch {
      toast.error("שמירה נכשלה");
    } finally {
      setSaving(false);
    }
  }

  if (!s) return <div>טוען...</div>;

  return (
    <div className="max-w-2xl">
      <h1 className="font-display text-3xl font-bold text-primary mb-6">הגדרות אתר</h1>
      <div className="rounded-lg bg-card p-6 shadow-card border border-border space-y-5">
        <h2 className="font-display text-lg font-bold">פרטי קשר</h2>
        <div><Label>טלפון</Label><Input value={s.contact_phone || ""} onChange={(e) => setS({ ...s, contact_phone: e.target.value })} /></div>
        <div><Label>אימייל</Label><Input type="email" value={s.contact_email || ""} onChange={(e) => setS({ ...s, contact_email: e.target.value })} /></div>
        <div><Label>כתובת</Label><Input value={s.contact_address || ""} onChange={(e) => setS({ ...s, contact_address: e.target.value })} /></div>

        <div className="border-t pt-5">
          <h2 className="font-display text-lg font-bold mb-3">הגדרות התראות הרשמה</h2>
          <div><Label>אימייל לקבלת התראות על הרשמות חדשות</Label><Input type="email" value={s.notification_email || ""} onChange={(e) => setS({ ...s, notification_email: e.target.value })} placeholder="admin@example.com" /></div>
          <div className="mt-3"><Label>שם השולח</Label><Input value={s.from_name || ""} onChange={(e) => setS({ ...s, from_name: e.target.value })} /></div>
          <div className="mt-3"><Label>קידומת לנושא המייל</Label><Input value={s.subject_prefix || ""} onChange={(e) => setS({ ...s, subject_prefix: e.target.value })} /></div>
          <p className="text-xs text-muted-foreground mt-2">המייל יישלח אוטומטית בכל הרשמה חדשה. כל ההרשמות נשמרות תמיד בעמוד "הרשמות" גם ללא הגדרת מייל.</p>
        </div>

        <Button onClick={save} disabled={saving}>{saving ? "שומר..." : "שמור"}</Button>
      </div>
    </div>
  );
}
